import { ifBasePath } from '../../config/baseConfig';
import Redux from '../../redux/ReduxConnector';
import LocalStorage, { LocalStorageKey } from '../../utils/LocalStorage';

export const getAggregationByAggregateDate = async (aggregateDate: string): Promise<Array<any>> => {
  const response = await fetch(
    `${ifBasePath}tenant/1853391b-a49d-4232-b0e1-c310a904a394/aggregation/date/${aggregateDate}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': Redux.getStore().user.accessToken || LocalStorage.get(LocalStorageKey.ACCESS_TOKEN) || ''
      }
    }
  );
  if (!response.ok) {
    throw new Error(`HTTP error: ${response.status}`);
  }
  const result = await response.json();

  console.log('end getAggregationByAggregateDate');
  console.log(result);
  return result;
};
